'use client'

import { ArrowRight } from 'lucide-react'
import { useButtonTracking } from '@/lib/useButtonTracking'

const SKILLS_REPO_URL = 'https://github.com/AI-Builder-Club/skills'

export default function SkillsRepoCta({ postId }: { postId: string }) {
  const { trackButtonClick } = useButtonTracking()

  return (
    <a
      href={SKILLS_REPO_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        trackButtonClick('skills_repo_cta_click', {
          post_id: postId,
          section: 'blog_mid',
          destination: 'github_skills_repo',
          conversion: true,
        })
      }
      className="block border border-emerald-900/60 bg-gradient-to-br from-emerald-950/40 to-gray-900/60 rounded-xl p-6 hover:border-emerald-700 transition-all group not-prose"
    >
      <p className="text-xs uppercase tracking-wide text-emerald-400 font-semibold mb-2">
        AI Builder Club Skills · Open source
      </p>
      <h3 className="text-xl font-bold text-white mb-2">
        The starter kit for the setup above.
      </h3>
      <p className="text-sm text-gray-300 mb-4 leading-relaxed">
        The skills my team runs in production: onboard a repo to agent-driven dev, give
        every agent its own isolated stack, make the work verifiable, and bootstrap the
        shared memory your loops read and write.
      </p>
      <span className="inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:gap-3 transition-all">
        Get the skills on GitHub <ArrowRight className="w-4 h-4" />
      </span>
    </a>
  )
}
